module.exports = __webpack_public_path__ + "img/bogota.ec431d49.jpg";